<script>
export default {
  name: 'InputComment',
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    value: Proptypes.string(''),
    disabled: Proptypes.boolean(false),
    maxLenOfComment: Proptypes.number(),
    placeholder: Proptypes.string(''),
  },
  computed: {
    commentValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update', newValue)
      },
    },
    limitOfCharacters() {
      return `${this.commentValue?.length}/${this.maxLenOfComment}`
    },
  },
}
</script>

<template>
  <div>
    <v-textarea
      v-model="commentValue"
      filled
      auto-grow
      class="tamara-base-comment-input"
      :placeholder="placeholder"
      rows="4"
      row-height="22"
      :maxlength="maxLenOfComment"
      :disabled="disabled"
    />
    <div class="d-flex justify-end gray--text">
      {{ limitOfCharacters }}
    </div>
  </div>
</template>

<style lang="scss">
.tamara-base-comment-input {
  background: #fff;

  &.v-input--is-focused,
  &.v-input--is-dirty {
    .v-input__slot {
      box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.05);
    }
  }

  .v-input__slot {
    padding: 12px 16px !important;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    background: inherit !important;

    textarea {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
    }

    &::before,
    &::after {
      display: none !important;
    }
  }

  .v-text-field__details {
    display: none !important;
  }
}
</style>
